import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './style.scss';

interface MenuBarProps {}

export const MenuBar: React.FC<MenuBarProps> = () => {
    const location = useLocation();

    const isActive = (path: string): boolean => {
        return location.pathname === path || location.pathname.startsWith(path + '/');
    };

    const menuItems = [
        { path: '/', label: 'Dashboard', icon: 'bx-home' },
        { path: '/orders/', label: 'Orders', icon: 'bx-bar-chart' },
        { path: '/closed-positions/', label: 'Closed', icon: 'bx-check-circle' },
        { path: '/portfolio/', label: 'Allocation', icon: 'bx-pie-chart-alt' },
    ];

    return (
        <nav className='menu-bar'>
            <div className='menu-container'>
                {menuItems.map((item) => (
                    <Link
                        key={item.path}
                        to={item.path}
                        className={`menu-item ${isActive(item.path) ? 'active' : ''}`}
                        title={item.label}
                    >
                        <i className={`bx ${item.icon}`}></i>
                        <span className='menu-label'>{item.label}</span>
                    </Link>
                ))}
            </div>
        </nav>
    );
};
